export * from './entity-mapping.constant';
export * from './person-property-mapping.constant';

import { FieldData } from '@ptg-shared/types/models';

export const MODULE_KEY = 'entity-management-module';

export const IDENTIFIER_PATTERN_DEFAULT_VALUE = '#######';

export const FixedPropertyKey = {
  DateOfDeath: 'dateOfDeath',
  LineOfDutyDeath: 'lineOfDutyDeath',
  NewHireExam: 'newHireExam',
  NewHireExamDate: 'newHireExamDate',
  RetireRehire: 'retireRehire',
  RelationShip: 'relationship',
  Payee: 'payee',
  CourtOrderType: 'courtOrderType',
  StatusCourtOrder: 'statusCourtOrder',
  RejectReason: 'rejectReason',
  BlankSpace: 'blankSpace',
  QDROOnFile: 'QDROOnFile',
  EnrollmentDate: 'enrollmentDate',
  ReportedAccidentOnFile: 'reportedAccidentOnFile'
};

export const LIMIT_PHONE_NUMBER = new RegExp(/^(\d{3})(\d{3})(\d{4})$/);

export const LIST_INPUT_ADDRESS: FieldData[] = [
  new FieldData('street1', 'Street1', 'Street1', 'text', true, '46', 'w380'),
  new FieldData('street2', 'Street2', 'Street 2 (Apartment No./Suite No.)', 'text', false, '46', 'w380'),
  new FieldData('city', 'City', 'City', 'text', true, '46', 'w182'),
  new FieldData('state', 'State', 'State/Province/Territory', 'select', true, 'none', 'w182'),
  new FieldData('zipCode', 'ZipCode', 'Zip Code/Postal Code', 'text', true, '10', 'w182'),
  new FieldData('country', 'Country', 'Country', 'select', true, 'none', 'w182'),
  new FieldData('effectFrom', 'EffectFrom', 'Effective From', 'date', true, 'none', 'w380'),
  new FieldData('effectTo', 'EffectTo', 'Effective To', 'date', false, 'none', 'w380'),
];
export const LIST_INPUT_PERSON_NAME: FieldData[] = [
  new FieldData('prefix', 'Prefix', 'Prefix', 'select', false, 'none', 'w167'),
  new FieldData('first', 'First', 'First Name', 'text', true, 'none', 'w152 first-name'),
  new FieldData('middle', 'Middle', 'Middle Name', 'text', false, 'none', 'w152'),
  new FieldData('last', 'Last', 'Last Name', 'text', true, 'none', 'w152 last-name'),
  new FieldData('suffix', 'Suffix', 'Suffix', 'text', false, 'none', 'w89'),
];
export const LIST_INPUT_STATUS: FieldData[] = [
  new FieldData('status', 'Status', 'Status', 'select', true, 'none', 'w167'),
  new FieldData('event', 'Event', 'Event', 'select', true, 'none', 'w167'),
];

export const StatusCourtOrder = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Terminated: 'Terminated',
};

export const CourtOrderType = {
  Garnishment: 'GNM',
  QDRO: 'QDR',
};

export const UnitedStates = 'USA';
